var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgYellowSmiley = function SvgYellowSmiley(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5CE00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21652_14157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 30H31.5",
    stroke: "#002039",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 22.5C18.4926 22.5 19.5 21.4926 19.5 20.25C19.5 19.0074 18.4926 18 17.25 18C16.0074 18 15 19.0074 15 20.25C15 21.4926 16.0074 22.5 17.25 22.5Z",
    fill: "#002039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 22.5C31.9926 22.5 33 21.4926 33 20.25C33 19.0074 31.9926 18 30.75 18C29.5074 18 28.5 19.0074 28.5 20.25C28.5 21.4926 29.5074 22.5 30.75 22.5Z",
    fill: "#002039"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21652_14157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYellowSmiley);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iMjQiIGZpbGw9IiNGNUNFMDAiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxNjUyXzE0MTU3KSI+CjxwYXRoIGQ9Ik0xNi41IDMwSDMxLjUiIHN0cm9rZT0iIzAwMjAzOSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE3LjI1IDIyLjVDMTguNDkyNiAyMi41IDE5LjUgMjEuNDkyNiAxOS41IDIwLjI1QzE5LjUgMTkuMDA3NCAxOC40OTI2IDE4IDE3LjI1IDE4QzE2LjAwNzQgMTggMTUgMTkuMDA3NCAxNSAyMC4yNUMxNSAyMS40OTI2IDE2LjAwNzQgMjIuNSAxNy4yNSAyMi41WiIgZmlsbD0iIzAwMjAzOSIvPgo8cGF0aCBkPSJNMzAuNzUgMjIuNUMzMS45OTI2IDIyLjUgMzMgMjEuNDkyNiAzMyAyMC4yNUMzMyAxOS4wMDc0IDMxLjk5MjYgMTggMzAuNzUgMThDMjkuNTA3NCAxOCAyOC41IDE5LjAwNzQgMjguNSAyMC4yNUMyOC41IDIxLjQ5MjYgMjkuNTA3NCAyMi41IDMwLjc1IDIyLjVaIiBmaWxsPSIjMDAyMDM5Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjE2NTJfMTQxNTciPgo8cmVjdCB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";